var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriverDocsAct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#0065FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    stroke: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8603 9.33314H15.3336C14.0302 9.33916 12.9222 10.2865 12.7136 11.5731C11.437 11.7458 10.4819 12.8316 10.4736 14.1198V19.5665C10.4719 20.3892 10.7979 21.1787 11.3796 21.7605C11.9614 22.3422 12.7509 22.6683 13.5736 22.6665H16.907C18.1659 22.667 19.2442 21.7655 19.467 20.5265C20.6853 20.255 21.5523 19.1747 21.5536 17.9265V11.9998C21.5537 11.2879 21.2691 10.6056 20.7632 10.1047C20.2573 9.60383 19.5722 9.32602 18.8603 9.33314ZM14.787 12.5865H18.3803C18.6564 12.5865 18.8803 12.8103 18.8803 13.0865C18.8803 13.3626 18.6564 13.5865 18.3803 13.5865H14.787C14.5108 13.5865 14.287 13.3626 14.287 13.0865C14.287 12.8103 14.5108 12.5865 14.787 12.5865ZM13.547 21.7798H16.8803C17.6354 21.7807 18.3042 21.2926 18.5336 20.5731H15.3336C13.8609 20.5731 12.667 19.3792 12.667 17.9065V12.4531C11.8899 12.6324 11.338 13.3223 11.3336 14.1198V19.5665C11.3409 20.7858 12.3276 21.7725 13.547 21.7798ZM14.287 17.3798C14.287 17.1037 14.5108 16.8798 14.787 16.8798H17.3336C17.6098 16.8798 17.8336 17.1037 17.8336 17.3798C17.8336 17.656 17.6098 17.8798 17.3336 17.8798H14.787C14.5108 17.8798 14.287 17.656 14.287 17.3798ZM14.787 15.7331H19.407C19.6831 15.7331 19.907 15.5093 19.907 15.2331C19.907 14.957 19.6831 14.7331 19.407 14.7331H14.787C14.5108 14.7331 14.287 14.957 14.287 15.2331C14.287 15.5093 14.5108 15.7331 14.787 15.7331Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverDocsAct);
export default __webpack_public_path__ + "static/media/driverDocsAct.9314e0e4863db0828a34f68deda2f9f5.svg";
export { ForwardRef as ReactComponent };